export class MaxContentLengthExceededError extends Error {
    constructor(message = 'Content size exceeds the maximum allowed.') {
        super(message);
        this.name = 'MaxContentLengthExceededError';
    }
}